import React, { useState, useEffect } from 'react';
import { Card, Input, Spin, Alert, Tooltip, Modal, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { Button } from '../ui/button';
import { api } from '../../api';

export const ApiKeySection = () => {
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [regenerating, setRegenerating] = useState(false);

  const fetchApiKey = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await api.auth.getApiKey();
      setApiKey(response.apiKey);
    } catch (error) {
      setError('Failed to load API key. Please try again later.');
      console.error('Error fetching API key:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRegenerateApiKey = () => {
    try {
      setRegenerating(true);
      setError(null);
      // const response = await api.auth.regenerateApiKey();
      throw new Error('Not implemented');
      // setApiKey(response.apiKey);
      // message.success('API key regenerated successfully');
    } catch (error) {
      setError('Failed to regenerate API key. Please try again later.');
      console.error('Error regenerating API key:', error);
    } finally {
      setRegenerating(false);
    }
  };

  useEffect(() => {
    void fetchApiKey();
  }, []);

  return (
    <Card title="API Key">
      <p>
        Your API key provides access to the Elementus Attribution API. Keep this
        key secure and do not share it with others.
      </p>

      {loading ? (
        <Spin />
      ) : error ? (
        <Alert type="error" message={error} />
      ) : (
        <>
          <Input.Group compact style={{ marginBottom: 16 }}>
            <Input
              style={{ width: 'calc(100% - 100px)' }}
              value={apiKey || ''}
              readOnly
              placeholder="No API key found"
            />
            <Tooltip title="Copy to clipboard">
              <Button
                variant="outline"
                size="icon"
                onClick={async () => {
                  if (apiKey) {
                    await navigator.clipboard.writeText(apiKey);
                    message.success('API key copied to clipboard');
                  }
                }}
                disabled={!apiKey}
              >
                <CopyOutlined />
              </Button>
            </Tooltip>
          </Input.Group>

          <Button
            disabled={true}
            variant="destructive"
            onClick={() => {
              Modal.confirm({
                title: 'Regenerate API Key',
                content:
                  'Are you sure you want to regenerate your API key? This will invalidate your current key and any applications using it will stop working.',
                onOk: handleRegenerateApiKey,
                okText: 'Yes, regenerate',
                cancelText: 'Cancel',
              });
            }}
            className={regenerating ? 'opacity-50' : ''}
          >
            Regenerate API Key
          </Button>
        </>
      )}
    </Card>
  );
};
